// extracted by mini-css-extract-plugin
export var successStoriesItem = "SuccessStoriesItem-module--successStoriesItem--3kfiQ";
export var successStoriesItem_active = "SuccessStoriesItem-module--successStoriesItem_active--Vadr9";
export var successStoriesItem__title = "SuccessStoriesItem-module--successStoriesItem__title--3B3vi";
export var successStoriesItem__name = "SuccessStoriesItem-module--successStoriesItem__name--13neI";
export var successStoriesItem__text = "SuccessStoriesItem-module--successStoriesItem__text--1Ufz6";